import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { TournamentReportPeriodForm } from '../TournamentReportPeriodForm';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

export function UnionMemberSchoolsTournamentsReportForm(props: Props) {
  return (
    <TournamentReportPeriodForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_TOURNAMENTS}
      description="View tournament participation by union member schools during the selected reporting period."
    />
  );
}
